import { useQuery } from "@tanstack/react-query";

import { auth } from "~/lib/firebase";

/**
 * Resolves once Firebase Auth has finished rehydrating its persisted session.
 *
 * Use inside React to gate any UI that needs a settled auth state on first
 * paint (route guards, splash → app transition). The result is cached with an
 * infinite stale time so subsequent calls are free.
 */
export function useFirebaseAuthState() {
  return useQuery({
    queryKey: ["auth", "firebase"],
    queryFn: async () => {
      await auth.authStateReady();
      return { ready: true } as const;
    },
    staleTime: Number.POSITIVE_INFINITY
  });
}
